import { NavFilterTile } from "../../core/blocks/NavFilterTile";
import { setMarketPlace } from "../../../redux/reducers/marketPlace";
import {
  CA,
  US,
  MX,
  BR,
  GB,
  DE,
  NL,
  ES,
  SE,
  PL,
  BE,
  AE,
  SA,
  FR,
  IT,
  IE,
  IN,
  TR,
  AU,
  JP,
  SG,
} from "country-flag-icons/react/3x2";
import { useOrgMarketplaceKeys } from "../../../modules/admin/api/useOrgMarketplaces";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { useSetDefaultMarketplace } from "../../../modules/admin/api/useSetDefaultMarketplace";
import { useTranslation } from "react-i18next";

function SellerMarketplace({ mobileSidebarItem }: { mobileSidebarItem?: boolean }) {
  const { t } = useTranslation(["common"]);
  const dispatch = useAppDispatch();
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  const marketPlacesQuery = useOrgMarketplaceKeys();
  const setDefaultMarketplaceMutation = useSetDefaultMarketplace();

  const onMarketplaceClick = (id: string) => {
    dispatch(setMarketPlace(id));
    localStorage.setItem("Marketplace", id);
    setDefaultMarketplaceMutation.mutate(id);

    if (window.location.href.includes("dsp")) {
      window.location.href = "/user/dsp";
    }
  };

  const items = [
    { header: true as const, label: t(($) => $.common.navbar["North America"]) },
    {
      value: "CA",
      label: t(($) => $.common.countries["Canada"]),
      icon: <CA className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("CA"),
    },
    {
      value: "USA",
      label: t(($) => $.common.countries["United States"]),
      icon: <US className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("USA"),
    },
    {
      value: "MX",
      label: t(($) => $.common.countries["Mexico"]),
      icon: <MX className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("MX"),
    },
    {
      value: "BR",
      label: t(($) => $.common.countries["Brazil"]),
      icon: <BR className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("BR"),
    },
    { header: true as const, label: t(($) => $.common.navbar["Europe"]) },
    {
      value: "UK",
      label: t(($) => $.common.countries["United Kingdom"]),
      icon: <GB className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("UK"),
    },
    {
      value: "DE",
      label: t(($) => $.common.countries["Germany"]),
      icon: <DE className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("DE"),
    },
    {
      value: "NL",
      label: t(($) => $.common.countries["Netherlands"]),
      icon: <NL className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("NL"),
    },
    {
      value: "ES",
      label: t(($) => $.common.countries["Spain"]),
      icon: <ES className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("ES"),
    },
    {
      value: "SE",
      label: t(($) => $.common.countries["Sweden"]),
      icon: <SE className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("SE"),
    },
    {
      value: "PL",
      label: t(($) => $.common.countries["Poland"]),
      icon: <PL className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("PL"),
    },
    {
      value: "BE",
      label: t(($) => $.common.countries["Belgium"]),
      icon: <BE className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("BE"),
    },
    {
      value: "AE",
      label: t(($) => $.common.countries["UAE"]),
      icon: <AE className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("AE"),
    },
    {
      value: "SA",
      label: t(($) => $.common.countries["Saudi Arabia"]),
      icon: <SA className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("SA"),
    },
    {
      value: "FR",
      label: t(($) => $.common.countries["France"]),
      icon: <FR className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("FR"),
    },
    {
      value: "IT",
      label: t(($) => $.common.countries["Italy"]),
      icon: <IT className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("IT"),
    },
    {
      value: "IE",
      label: t(($) => $.common.countries["Ireland"]),
      icon: <IE className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("IE"),
    },
    {
      value: "IN",
      label: t(($) => $.common.countries["India"]),
      icon: <IN className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("IN"),
    },
    {
      value: "TR",
      label: t(($) => $.common.countries["Turkey"]),
      icon: <TR className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("TR"),
    },
    { header: true as const, label: t(($) => $.common.navbar["Far East"]) },
    {
      value: "AU",
      label: t(($) => $.common.countries["Australia"]),
      icon: <AU className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("AU"),
    },
    {
      value: "JP",
      label: t(($) => $.common.countries["Japan"]),
      icon: <JP className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("JP"),
    },
    {
      value: "SG",
      label: t(($) => $.common.countries["Singapore"]),
      icon: <SG className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("SG"),
    },
  ];

  return (
    <NavFilterTile
      items={items}
      mobileSidebarItem={mobileSidebarItem}
      selectedKey={marketPlace}
      onSelectionChange={onMarketplaceClick}
    />
  );
}

export default SellerMarketplace;
